import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('generic_benefits_set', baseUrl, 'benefits_set')
const actions = generator.generate()

function baseUrl(params) {
  return `/generic_benefits_sets/${params.productLine}`
}

export function withProductLine(productLine, method) {
  return (params, urlParams) => (
    method(params, { ...urlParams, productLine })
  )
}

export default actions
